import * as React from 'react';

const ChevronUpSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="chevron-up_svg__eds-icon--up-chevron_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="chevron-up_svg__eds-icon--up-chevron_base"
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#231F20"
            d="M12 8l-7 7 .7.7L12 9.4l6.3 6.3.7-.7z"
        />
    </svg>
);

ChevronUpSvg.displayName = 'ChevronUpSvg';
export default ChevronUpSvg;
